import {
  ECpiFilterTypes,
  TBctxHeaderItem,
  TCpiActions,
  TCpiActionsGroupedById,
  TCpiActionsWithBctxInfo,
  TCpiDefect,
  TCpiDefectiveOrRecutAction,
  TCpiDefectiveOrRecutActionWithSelectionInfo,
  TCpiDefectiveOrRecutForwardActionTypes,
  TCpiFilter,
  TCpiRectifiedOrReplacedAction,
  TCutPanelInspectionItemInfoList,
  TCutPanelInspectionRequestItem,
  TTagInfo,
  TCpiAddFttAction,
} from '@monorepo/types';
export const CpiHelper = {
  getTagType(firstChar: string) {
    switch (firstChar) {
      case '1':
        return 'MASTER_BUNDLE';
      case '2':
        return 'PER_PIECE';
      case '3':
        return 'COMPONENT_BUNDLE';
      default:
        return '';
    }
  },
  getPanelNumberFromPanelIdentifier(panelIdentifier: string) {
    return panelIdentifier.split('_')[2];
  },
  getUniqueIdentifierFromPanelIdentifier(panelIdentifier: string) {
    const splittedArray = panelIdentifier.split('_');
    return splittedArray[0] + '_' + splittedArray[1];
  },
  getTodaysDateFilter(): TCpiFilter {
    return {
      filterType: ECpiFilterTypes.DATE,
      values: [new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 999)],
    };
  },
  isActionFromOriginalInspection(
    actionId: string,
    actionType: string,
    dateTime: number,
    pastInspectionActions: TCpiActions = [],
  ): boolean {
    if (pastInspectionActions.length === 0) {
      return false;
    }

    return pastInspectionActions.some(
      (action) =>
        action.id === actionId &&
        action.type === actionType &&
        action.eventType === 'FORWARD' &&
        action.dateTime === dateTime,
    );
  },
  createFttAction(fttValue: number): TCpiAddFttAction {
    return {
      type: 'FTT',
      dateTime: Date.now(),
      value: fttValue,
    };
  },
  transformApiResponseAndGetActionsListWithBctxInfo(list: TCutPanelInspectionItemInfoList[]) {
    const actionsWithBctxInfo: TCpiActionsWithBctxInfo = [];
    list.forEach((listItem) => {
      const actions: TCpiDefectiveOrRecutAction[] = [];
      listItem.recut.map((recutIssue) => {
        CpiHelper.transformApiReponseAndupdateActionsList(recutIssue, actions, 'RECUT', listItem.updatedTime);
      });
      listItem.defectives.map((defectiveIssue) => {
        CpiHelper.transformApiReponseAndupdateActionsList(defectiveIssue, actions, 'DEFECTIVE', listItem.updatedTime);
      });
      actionsWithBctxInfo.push({
        actions,
        bctx: CpiHelper.getBctxHeader(listItem.tagDetails),
      });
    });
    return actionsWithBctxInfo;
  },
  transformApiReponseAndupdateActionsList(
    cpiDefect: TCpiDefect,
    actions: TCpiDefectiveOrRecutAction[],
    type: TCpiDefectiveOrRecutForwardActionTypes,
    updatedTime: number,
  ) {
    cpiDefect.panelIdentifiers.map((panelIdentifier) => {
      const actionId = CpiHelper.getUniqueIdentifierFromPanelIdentifier(panelIdentifier);
      const item = actions.find((action) => action.id === actionId);
      const issue: TCpiDefectiveOrRecutAction['issues'][number] = {
        category_id: '',
        group_id: [],
        group_name: '',
        id: cpiDefect.id,
        name: cpiDefect.name,
      };
      if (item) {
        actions.forEach((action) => {
          if (action.id === actionId) {
            action.issues.push(issue);
          }
        });
      } else {
        const newAction: TCpiDefectiveOrRecutAction = {
          dateTime: updatedTime,
          eventType: 'FORWARD',
          id: actionId,
          issues: [issue],
          panelIdentifier,
          round: 1,
          type,
        };
        actions.push(newAction);
      }
    });
  },
  getTransformedActionsItemForApiRequest(
    actions: TCpiActionsWithBctxInfo[number]['actions'],
    tagId: string,
    ftt: number,
  ): TCutPanelInspectionRequestItem {
    const allActionsGroupedByIdForEachItem = actions.reduce((acc, val) => {
      if (acc[val.id]) acc[val.id].push(val);
      else acc[val.id] = [val];
      return acc;
    }, {} as TCpiActionsGroupedById);
    const recut: TCpiDefect[] = [];
    const defectives: TCpiDefect[] = [];
    const replacedOrRectifiedPanelIdentifier: string[] = [];
    Object.values(allActionsGroupedByIdForEachItem).map((actions) => {
      const lastEventForCurrentItem = CpiHelper.getLastForwardEventForCurrentItemFromActionsList(actions);
      if (lastEventForCurrentItem) {
        const lastEvent = lastEventForCurrentItem;
        switch (lastEvent.type) {
          case 'RECUT': {
            lastEvent.issues.forEach((issue) => {
              if (recut.find((r) => r.id === issue.id)) {
                recut.map((r) => {
                  if (r.id === issue.id) {
                    r.qty += 1;
                    r.panelIdentifiers.push(lastEvent.panelIdentifier);
                  }
                });
              } else {
                recut.push({
                  id: issue.id,
                  name: issue.name,
                  panelIdentifiers: [lastEvent.panelIdentifier],
                  qty: 1,
                });
              }
            });
            break;
          }
          case 'DEFECTIVE': {
            lastEvent.issues.forEach((issue) => {
              if (defectives.find((d) => d.id === issue.id)) {
                defectives.map((d) => {
                  if (d.id === issue.id) {
                    d.qty += 1;
                    d.panelIdentifiers.push(lastEvent.panelIdentifier);
                  }
                });
              } else {
                defectives.push({
                  id: issue.id,
                  name: issue.name,
                  panelIdentifiers: [lastEvent.panelIdentifier],
                  qty: 1,
                });
              }
            });
            break;
          }
          case 'RECTIFIED':
          case 'REPLACED':
            replacedOrRectifiedPanelIdentifier.push(lastEvent.panelIdentifier);
            break;
          default:
            break;
        }
      }
    });
    return {
      tagId,
      ftt,
      recut,
      defectives,
      replacedOrRectifiedPanelIdentifier,
    };
  },
  getLastForwardEventForCurrentItemFromActionsList(actions: TCpiActions) {
    let lastEventForCurrentItem: TCpiActions[number] | undefined;
    const reversedEventsForCurrentItem = [...actions].reverse();
    let UNDO_COUNT = 0;
    for (let i = 0; i < reversedEventsForCurrentItem.length; i++) {
      if (reversedEventsForCurrentItem[i].eventType === 'FORWARD') {
        if (UNDO_COUNT === 0) {
          lastEventForCurrentItem = reversedEventsForCurrentItem[i];
          break;
        } else {
          UNDO_COUNT -= 1;
        }
      } else {
        UNDO_COUNT += 1;
      }
    }
    return lastEventForCurrentItem;
  },
  getValueForTheSelectedKey(keyValuePairs: TTagInfo[], keyToFind: string) {
    return (keyValuePairs.find((item) => item.k === keyToFind)?.v || '-') as string;
  },
  doesKeyExistInTagInfo(key: string, tagData: TTagInfo[]): boolean {
    return tagData.some((t) => t.k === key);
  },
  getBctxHeader(tagData: TTagInfo[]): TBctxHeaderItem[] {
    return [
      {
        label: 'cpi.models.buyer',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'buyer'),
      },
      {
        label: 'cpi.models.po',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'po'),
      },
      ...(CpiHelper.doesKeyExistInTagInfo('order_ref', tagData)
        ? [{ label: 'cpi.models.order_ref', value: CpiHelper.getValueForTheSelectedKey(tagData, 'order_ref') }]
        : []),
      {
        label: 'cpi.models.product_type',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'product_type'),
      },
      {
        label: 'cpi.models.style',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'style'),
      },
      {
        label: 'cpi.models.color',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'color'),
      },
      {
        label: 'cpi.models.size',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'size'),
      },
      {
        label: 'cpi.models.tag_id',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'displayComponentTag'),
      },
      {
        label: 'cpi.models.bundle_no',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'componentBundleNumber'),
      },
      {
        label: 'cpi.models.cut_no',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'cutNo'),
      },
      {
        label: 'cpi.models.component',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'componentType'),
      },
      {
        label: 'cpi.models.fabric_type',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'fabricType'),
      },
      {
        label: 'cpi.models.fabric_color',
        value: CpiHelper.getValueForTheSelectedKey(tagData, 'fabricColor'),
      },
    ];
  },
  transformRawDataAndGenerateToBeRectifiedReplacedApiItems(
    selectedRows: TCpiDefectiveOrRecutActionWithSelectionInfo[],
    rawData: TCutPanelInspectionItemInfoList[],
    newMarkedItems: TCpiDefectiveOrRecutAction[] | TCpiRectifiedOrReplacedAction[],
    type: 'RECTIFY' | 'ISSUE', // marked items are getting rectified or it is a single item for recut/defect issue addition
  ): TCutPanelInspectionRequestItem[] {
    const items: TCutPanelInspectionRequestItem[] = [];
    selectedRows.forEach((selectedRow, selectedRowIndex) => {
      const rowTagId = selectedRow.bctx.find((elem) => elem.label === 'cpi.models.tag_id')?.value; // Because bctx header has a label of Tag ID instead of 'displayComponentTag' (it will be there in case of bctx info and not in case of bctx header info)
      if (!rowTagId) return;

      const componentTagWithInspectionDetails = [...rawData].find((elem) => elem.tagId === rowTagId);
      if (componentTagWithInspectionDetails) {
        selectedRow.issues.forEach((issue) => {
          // Remove newly added issue from defectives and recut panel identifiers list
          const defect = componentTagWithInspectionDetails.defectives.find((def) => def.id === issue.id);
          if (defect) {
            const index = defect.panelIdentifiers.indexOf(selectedRow.panelIdentifier);
            if (index !== -1) {
              defect.panelIdentifiers.splice(index, 1);
            }
          }
          const recut = componentTagWithInspectionDetails.recut.find((rec) => rec.id === issue.id);
          if (recut) {
            const index = recut.panelIdentifiers.indexOf(selectedRow.panelIdentifier);
            if (index !== -1) {
              recut.panelIdentifiers.splice(index, 1);
            }
          }
        });

        // remove empty issues list which does not have any panelIdentifiers
        componentTagWithInspectionDetails.defectives = componentTagWithInspectionDetails.defectives.filter(
          (defective) => defective.panelIdentifiers.length !== 0,
        );
        componentTagWithInspectionDetails.recut = componentTagWithInspectionDetails.recut.filter(
          (recut) => recut.panelIdentifiers.length !== 0,
        );

        // get data transformed to actions
        const otherPanelsTransformedToActions = CpiHelper.transformApiResponseAndGetActionsListWithBctxInfo([
          componentTagWithInspectionDetails,
        ]).map((item) => item.actions);

        // get actions transformed to API request item by sending old actions, and the newly added action
        const transformedApiRequest = CpiHelper.getTransformedActionsItemForApiRequest(
          [...otherPanelsTransformedToActions[0], newMarkedItems[selectedRowIndex]],
          rowTagId,
          componentTagWithInspectionDetails.ftt,
          // type === 'ISSUE'
          //   ? componentTagWithInspectionDetails.ftt
          //   : componentTagWithInspectionDetails.ftt +
          //       selectedRows.filter((row) => row.bctx.find((elem) => elem.label === 'Tag ID')?.value === rowTagId)
          //         .length, // added (+) because one or more panels could have been rectified for the same component tag
        );
        const itemIndex = items.map((item) => item.tagId).indexOf(rowTagId);
        if (itemIndex !== -1) {
          items[itemIndex] = {
            ...transformedApiRequest,
            replacedOrRectifiedPanelIdentifier: [
              ...items[itemIndex].replacedOrRectifiedPanelIdentifier,
              ...transformedApiRequest.replacedOrRectifiedPanelIdentifier,
            ],
          };
        } else {
          items.push(transformedApiRequest);
        }
      }
    });
    return items;
  },
  getHeaderLabels(headerKey: string) {
    switch (headerKey) {
      case 'buyer':
        return 'Buyer';
      case 'po':
        return 'PO';
      case 'product_type':
        return 'Product';
      case 'style':
        return 'Style';
      case 'color':
        return 'Color';
      case 'size':
        return 'Size';
      case 'componentBundleNumber':
        return 'Bundle No.';
      case 'cutNo':
        return 'Cut #';
      case 'componentType':
        return 'Component';
      default:
        return '';
    }
  },
  getAlreadySelectedPanelNumbers(cpiActions: TCpiActions): string[] {
    return CpiHelper.getOnlyForwardEventsFromActionsList(cpiActions)
      .map((action) => CpiHelper.getPanelNumberFromPanelIdentifier(action.panelIdentifier!));
  },
  getOnlyForwardEventsFromActionsList(actions: TCpiActions): TCpiActions {
    const undoSignatures = new Set(
      actions
        .filter((action) => action.eventType === 'UNDO')
        .map((action) => `${action.id}_${action.panelIdentifier}`)
    );
    return actions.filter(
      (action) =>
        action.eventType === 'FORWARD' &&
        !undoSignatures.has(`${action.id}_${action.panelIdentifier}`)
    );
  },
};
